import $ from 'jquery';

export default class VideoPlayerJW {
  constructor() {
    // This is required for GA4
    window.dataLayer = window.dataLayer || [];
    this.dataLayer = window.dataLayer || [];
    this.gaObjects = $('[data-ga-type]');
    this.bodyRef = $('body');
    this.defaultConfig = {
      // autoPause ensures the video is paused if the player is not in the viewable area.
      // This is mandatory to be enabled.
      autoPause: { viewability: true },
      autostart: false,
      mute: false,
      ga4analytics: true,
      repeat: false,
      logo: false,
      sharing:
      {
        sites: [
          'facebook',
          'twitter',
          'linkedin',
          'email',
        ],
      },
    };
  }

  init() {
    /**
     * Redirection to specified URL
     * @param {String} elementId - id of the html element
     * @param {String} instanceConfig - object with video configuration parameters
    */
    const setupVideoPlayer = (elementId, instanceConfig) => {
      if (typeof window.jwplayer !== 'function') {
        throw new Error('jwplayer() not available');
      }
      const container = document.getElementById(elementId);
      if (!container) {
        throw new Error(`No element with id "${elementId}"`);
      }

      // Fetch the config
      const config = { ...this.defaultConfig, ...instanceConfig };

      // Create the player based on the playername chosen where the player is called
      const player = window.jwplayer(elementId).setup(config);

      // To keep track of what play it is is looping
      let currentPlay = 0;

      // If the progress bar passes a treshold where we dont end up in an
      // exact 25, 50 or 75 value, we need to rather check if we pass a quartile
      // treshold rather than an exact number. E.g. if percentage go from 49%
      // to 51% we will not fail sending 50% progress.
      let firedQ = { 25: false, 50: false, 75: false };

      // Occasionally start can be trigged twice, this is to safeguard against
      // those occasions.
      let startFired = false;

      // Ensure initial values are correct on player ready
      player.on('ready', () => {
        startFired = false;
        firedQ = { 25: false, 50: false, 75: false };
      });

      // The request was to disable GA4 if autoplay is enabled
      const submitGA4Data = config.ga4analytics;

      // This will submit the GA4 data if enabled
      if (submitGA4Data) {
        // GA4 START event
        player.on('play', () => {
          if (!startFired) { // prevents multiple start events for same play
            window.dataLayer.push({
              event: 'ga4_video_start',
              ga4_data: {
                video_current_time: 0,
                video_duration: Math.floor(player.getDuration()),
                video_percent: 0,
                video_provider: 'JW Player',
                video_title: player.getPlaylistItem().title,
                video_url: player.getPlaylistItem().file,
                visible: player.getViewable(),
              },
            });
            startFired = true;
          }
        });

        player.on('seek', (evt) => {
        // This will skip firing of GA4 if the user drags the slider forward
          const dur = player.getDuration();
          const newPct = (evt.offset * 100) / dur;
          [25, 50, 75].forEach((q) => {
            if (newPct >= q) {
              firedQ[q] = true;
            }
          });
        });

        // GA4 PROGRESS event
        player.on('time', (e) => {
          const pct = (e.position * 100) / e.duration;
          [25, 50, 75].forEach((q) => {
            if (pct >= q && !firedQ[q]) {
              window.dataLayer.push({
                event: 'ga4_video_progress',
                ga4_data: {
                  video_current_time: Math.floor(e.position),
                  video_duration: Math.floor(e.duration),
                  video_percent: q,
                  video_provider: 'JW Player',
                  video_title: player.getPlaylistItem().title,
                  video_url: player.getPlaylistItem().file,
                  visible: player.getViewable(),
                },
              });
              firedQ[q] = true;
            }
          });
        });

        // GA4 COMPLETE event (reset quartiles and startFired if looping)
        player.on('complete', () => {
          window.dataLayer.push({
            event: 'ga4_video_complete',
            ga4_data: {
              video_current_time: Math.floor(player.getDuration()),
              video_duration: Math.floor(player.getDuration()),
              video_percent: 100,
              video_provider: 'JW Player',
              video_title: player.getPlaylistItem().title,
              video_url: player.getPlaylistItem().file,
              visible: player.getViewable(),
            },
          });

          // If looping, clear quartile and startFired flags for the next pass
          if (config.repeat) {
            firedQ = { 25: false, 50: false, 75: false };
            startFired = false;
          }
        });
      }

      // Stop after 3 loops (if the user restarts the player after looping
      // without refreshing the page, further looping will be disabled).
      player.on('complete', () => {
        currentPlay += 1;

        if (currentPlay >= 3) {
          player.stop();
        }
      });

      return player;
    };

    this.bodyRef.ready(() => {
      const playerWrappers = document.querySelectorAll('.video-wrapper');

      for (let i = 0; i < playerWrappers.length; i += 1) {
        const wrapperElem = playerWrappers[i];
        const jwPlayerVideo = $(wrapperElem.querySelectorAll('.jw-player')).children().first();

        if (jwPlayerVideo.length) {
          const jwPlayerID = jwPlayerVideo[0].id;
          const file = jwPlayerVideo.data('video-file');
          const image = jwPlayerVideo.data('video-image');
          const title = jwPlayerVideo.data('video-title');
          const description = jwPlayerVideo.data('video-description');
          const repeat = jwPlayerVideo.data('video-repeat') || false;
          const autostart = jwPlayerVideo.data('video-autostart') || false;
          const mute = jwPlayerVideo.data('video-mute') || false;
          const controls = jwPlayerVideo.data('controls') || false;
          const stretching = jwPlayerVideo.data('stretching') || 'uniform';
          const overlayStart = wrapperElem.querySelectorAll('.overlay-start')[0];
          const overlayEnd = wrapperElem.querySelectorAll('.overlay-end')[0];
          const playBtn = wrapperElem.querySelectorAll('.play-btn')[0];

          const player = setupVideoPlayer(
            jwPlayerID,
            {
              playlist: [{
                file,
                image,
                title,
                description,
              }],
              repeat,
              autostart,
              mute,
              controls,
              stretching,
              overlayStart,
              overlayEnd,
              playBtn,
            },
          );

          player.on('complete', () => {
            if (overlayEnd && autostart === false) {
              overlayEnd.classList.add('is-visible');
              playBtn.classList.add('is-visible');
            }
          });

          if (playBtn) {
            playBtn.addEventListener('click', () => {
              player.on('firstFrame', () => {
                // If there is overlay on start of the video
                if (overlayStart) {
                  overlayStart.classList.remove('is-visible');
                }
                // If there is overlay on end of the video
                if (overlayEnd) {
                  overlayEnd.classList.remove('is-visible');
                }
              });

              playBtn.classList.remove('is-visible');
              player.play();
            });
          }
        }
      }
    });
  }
}
